module.exports = __webpack_public_path__ + "img/redWrap.2023138b.png";